import { computed, reactive } from 'vue';

export function useModals() {
    const modals = reactive({});

    const open = (name) => modals[name] = true;

    const close = (name) => modals[name] = false;

    const toggle = (name) => modals[name] = !modals[name];

    const isOpen = (name) => computed(() => !!modals[name]);

    const closeAll = () => {
        for (const key in modals) {
            modals[key] = false;
        }
    };

    return {
        open,
        close,
        toggle,
        isOpen,
        closeAll,
    };
}